import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class UserInforService {
  constructor() {}
  private userInfor: any = {};
  setUserInfo(userInfor: any) {
    this.userInfor = userInfor;
  }
  getUserInfo() {
    return this.userInfor;
  }
}
